function isFalseyOrEmpty(value) {
  if (!!value === false) return true;

  if (['number', 'boolean', 'string'].includes(typeof value)) return false;

  const hasKeys = !!Object.keys(value).length;
  if (Array.isArray(value)) return !value.length;
  if (typeof value.size !== 'undefined' && !hasKeys) return !value.size; // for map/set like items

  return !hasKeys;
}

module.exports = isFalseyOrEmpty;
